import { render, staticRenderFns } from "./TrainingListItem.vue?vue&type=template&id=507eac7e&"
import script from "./TrainingListItem.vue?vue&type=script&lang=js&"
export * from "./TrainingListItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "TrainingListItem.vue"
export default component.exports